import(/* webpackMode: "eager" */ "/vercel/path0/app/atsumary/scan/page.tsx");
